import { Reducer } from "redux";
import {
  SCROLL_WORKSPACE,
  ScrollWorkspaceAction,
  SET_VOLUME_INDICATOR_VALUES,
  SetVolumeIndicatorValuesAction,
  SET_MASTER_VOLUME_INDICATOR_VALUES,
  SetMasterVolumeIndicatorvaluesAction,
  SET_MASTER_VOLUME,
  SetMasterVolumeAction,
  SET_MASTER_MUTE,
  SetMasterMuteAction,
  SET_METRONOME_VOLUME,
  SetMetronomeVolumeAction,
  SET_METRONOME_MUTE,
  SetMetronomeMuteAction,
  UI_SHOW_FX_PANEL,
  UIShowFXPanelAction,
  SetAlertAction,
  ClearAlertAction,
  CLEAR_ALERT,
  SET_ALERT,
  SetWaitMessageAction,
  SET_WAIT_MESSAGE,
  ZoomChangeAction,
  SetSnapModeAction,
  SET_SNAP_MODE,
  ZOOM_CHANGE,
  ZOOM_HOVER,
  ZoomButtonHoverAction
} from "../actions/actionTypes";
import { UIState, SnapMode } from "../store";

export let initialUiState: UIState = {
  activeFxLane: null,
  projectScrollX: 0,
  volumeIndicators: {},
  masterVolumeIndicator: {
    currentPeak: 0,
    recentPeak: 0
  },
  masterVolume: 0,
  masterMute: false,
  metronomeVolume: 0,
  metronomeMute: true,
  alert: null,
  waitMessage: null,
  snap: SnapMode.BAR,
  zoomLevel: 1.9,
  zoomHover: false
};

export const uiStateReducer: Reducer<
  UIState,
  | ZoomChangeAction
  | SetSnapModeAction
  | UIShowFXPanelAction
  | ScrollWorkspaceAction
  | SetVolumeIndicatorValuesAction
  | SetMasterVolumeIndicatorvaluesAction
  | SetMasterVolumeAction
  | SetMasterMuteAction
  | SetMetronomeVolumeAction
  | SetMetronomeMuteAction
  | SetAlertAction
  | ClearAlertAction
  | SetWaitMessageAction
  | ZoomButtonHoverAction
> = (state = initialUiState, action) => {
  switch (action.type) {
    case SET_SNAP_MODE:
      return {
        ...state,
        snap: action.snapMode
      };
    case ZOOM_CHANGE:
      return {
        ...state,
        zoomLevel: action.newZoomLevel
      };
    case ZOOM_HOVER:
      return {
        ...state,
        zoomHover: action.zoomHover
      };
    case UI_SHOW_FX_PANEL:
      return {
        ...state,
        activeFxLane: action.laneId
      };
    case SCROLL_WORKSPACE:
      return {
        ...state,
        projectScrollX: action.x
      };
    case SET_VOLUME_INDICATOR_VALUES:
      return {
        ...state,
        volumeIndicators: {
          ...state.volumeIndicators,
          [action.laneId]: {
            currentPeak: action.currentPeak,
            recentPeak: action.recentPeak
          }
        }
      };
    case SET_MASTER_VOLUME_INDICATOR_VALUES:
      if (
        state.masterVolumeIndicator.currentPeak === action.currentPeak &&
        state.masterVolumeIndicator.recentPeak === action.recentPeak
      )
        return state;
      return {
        ...state,
        masterVolumeIndicator: {
          currentPeak: action.currentPeak,
          recentPeak: action.recentPeak
        }
      };
    case SET_MASTER_VOLUME:
      return {
        ...state,
        masterVolume: action.volumeValue
      };
    case SET_MASTER_MUTE:
      return {
        ...state,
        masterMute: action.isMuted
      };
    case SET_METRONOME_VOLUME:
      return {
        ...state,
        metronomeVolume: action.volumeValue
      };
    case SET_METRONOME_MUTE:
      return {
        ...state,
        metronomeMute: action.isMuted
      };
    case SET_ALERT:
      return {
        ...state,
        alert: {
          id: action.id,
          role: action.role,
          title: action.title,
          message: action.message
        }
      };
    case CLEAR_ALERT:
      return {
        ...state,
        alert: null
      };
    case SET_WAIT_MESSAGE:
      return {
        ...state,
        waitMessage: action.message
          ? {
            id: action.id,
            role: action.role,
            message: action.message
          }
          : null
      };
    default:
      return state;
  }
};
